import s from './TourDescription.module.scss'

const TourDescription = ({ data }) => (
  <div className={s.root}>
    <p>
        {data?.description && (
            <div className={s.html}dangerouslySetInnerHTML={{ __html: data?.description }} />
        )}
    </p>
  </div>
);


export default TourDescription;
